import {
  Box, Grid, IconButton, Typography, Button, Alert, Modal,
  Divider, Avatar, Dialog, DialogTitle, DialogContent, DialogActions,
  RadioGroup, FormControlLabel, CircularProgress, Chip, Container,
  FormControl, Select, MenuItem, LinearProgress,
} from "@mui/material";
import Rating from "@mui/material/Rating";
import SeeAllReviews from "./SeeAllReviews";
import { Star, Twitter, YouTube, Facebook, Instagram } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import TuneIcon from "@mui/icons-material/Tune";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { Close } from "@mui/icons-material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import ReactPlayer from "react-player";
import SwiperCore, { Autoplay, Navigation, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { connect } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import PaymentIcon from "@mui/icons-material/Payment";
import * as Actions from "../../../redux/actions/";
import { Radio } from "@mui/material";
import config from "../../../config";
import Snackbar from "@mui/material/Snackbar";
import ListCard from "../../../components/listing/ListCard";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import ClearIcon from "@mui/icons-material/Clear";
import CustomModal from "../../../components/seller/listings/Modal";
import ServiceListCard from "../../../components/serviceListings/ServiceListCard";
import BlockIcon from "@mui/icons-material/Block";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PetsIcon from "@mui/icons-material/Pets";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import StarIcon from "@mui/icons-material/Star";

/* ── Rating bar row ─────────────────────────── */
const RatingBar = ({ stars, count, total }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
    <Typography sx={{ color: "#FFC001", fontSize: "12px", fontWeight: 700, width: 14, textAlign: "right" }}>{stars}</Typography>
    <StarIcon sx={{ color: "#FFC001", fontSize: 14 }} />
    <Box sx={{ flex: 1, height: 6, borderRadius: 3, backgroundColor: "#2a2a2a", overflow: "hidden" }}>
      <Box sx={{ width: total > 0 ? `${(count / total) * 100}%` : "0%", height: "100%", backgroundColor: "#FFC001", borderRadius: 3, transition: "width 0.4s ease" }} />
    </Box>
    <Typography sx={{ color: "#555", fontSize: "12px", width: 18, textAlign: "right" }}>{count}</Typography>
  </Box>
);

/* ── Section heading ────────────────────────── */
const SectionHead = ({ icon, label, accent }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
    {icon}
    <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: { xs: "18px", md: "22px" } }}>
      {label}{" "}<Box component="span" sx={{ color: "#FFC001" }}>{accent}</Box>
    </Typography>
  </Box>
);

/* ══════════════════════════════════════════════════════ */
const StoreDetails = ({ user, jwtToken, seller, loadListings, listings, classes, serviceListing, loadServiceListings }) => {
  const navigate = useNavigate();
  const { storeId } = useParams();
  const swiperRef = useRef(null);
  const playerRef = useRef(null);

  const [store, setStore] = useState({});
  const [isPlay, setIsPlay] = useState(true);
  const [isPlay2, setIsPlay2] = useState(false);
  const [isPlay3, setIsPlay3] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [openBlockModal, setOpenBlockModal] = useState(false);
  const [about, setAbout] = useState("");
  const [policy, setPolicy] = useState("");
  const [confirmProp, setConfirmProp] = useState(false);
  const [openSucessAlert, setOpenSucessAlert] = useState(false);
  const [trophyListings, setTrophyListing] = useState([]);
  const [showModal, setShowModal] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [reviewData, setReviewData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [reviewType, setReviewType] = useState("all");
  const [selectedSortValue, setSelectedSortValue] = useState("Newest");
  const [sortOrder, setSortOrder] = useState("desc");
  const [averageRating, setAverageRating] = useState(0);
  const [displayAnimalListings, setDisplayAnimalListings] = useState([]);
  const [displayServiceListings, setDisplayServiceListings] = useState([]);
  const [loadData, setLoadData] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  const plans = ["Silver", "Free"];

  SwiperCore.use([Autoplay]);

  useEffect(() => {
    setDisplayAnimalListings([]);
    setDisplayServiceListings([]);
  }, []);

  useEffect(() => {
    if (reviewData.length > 0) {
      const sum = reviewData.reduce((acc, d) => acc + d.rating, 0);
      setAverageRating((sum / reviewData.length).toFixed(2));
    } else {
      setAverageRating(0);
    }
  }, [reviewData]);

  useEffect(() => {
    const getStore = async () => {
      try {
        const { data: { data } } = await axios.get(`${config.SERVER_URL}/api/v1/stores/${storeId}`, {
          headers: { Authorization: `Bearer ${jwtToken}` },
        });
        setStore(data.store);
        setPolicy(data.store.policy);
        setAbout(data.store.about);
        loadListings({ sellerId: data.store.seller_id });
        loadServiceListings({ store_id: data.store.seller_id });
        setLoadData(false);
      } catch {
        setLoadData(false);
      }
    };
    getStore();
  }, [jwtToken, loadListings, storeId]);

  useEffect(() => {
    if (confirmProp && store?.seller) {
      const blockUser = async () => {
        try {
          await axios.post(`${config.SERVER_URL}/api/v1/blocks`, { block: { id: store.seller.user.id } }, {
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${jwtToken}` },
          });
        } catch {}
      };
      blockUser();
      setOpenSucessAlert(true);
      navigate("/neighbour");
    }
    return () => setConfirmProp(false);
  }, [confirmProp]);

  useEffect(() => { if (listings.length > 0 && !loadData) setDisplayAnimalListings(listings); }, [listings]);
  useEffect(() => { if (serviceListing.length > 0 && !loadData) setDisplayServiceListings(serviceListing); }, [serviceListing]);

  useEffect(() => {
    const fetchSellerReviews = async () => {
      try {
        const res = await axios.get(`${config.SERVER_URL}/api/v1/reviews?seller_id=${store?.seller_id}`, {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${jwtToken}` },
        });
        if (res.status === 200) {
          const filtered = res.data.reviews.filter((d) => {
            if (seller?.user?.subscriptions?.[0]?.plan?.name && plans.includes(seller.user.subscriptions[0].plan.name)) {
              return d.reviewable_type === "ListingAnimal";
            }
            return true;
          });
          setReviewData(filtered);
        }
      } catch {}
    };
    if (store?.seller_id) fetchSellerReviews();
  }, [store]);

  useEffect(() => {
    if (store?.trophy_cases?.length < 4) {
      setTrophyListing(store.trophy_cases.map(({ listing_animal }) => listing_animal));
    }
  }, [store]);

  const handleSortChange = async (e) => {
    const val = e.target.value;
    setSelectedSortValue(val);
    const order = val === "Newest" ? "desc" : val === "Oldest" ? "asc" : "default";
    setSortOrder(order);
    try {
      const res = await axios.get(`${config.SERVER_URL}/api/v1/reviews?sort_by=${order}&seller_id=${store.seller.id}`, {
        headers: { Authorization: `Bearer ${jwtToken}` },
      });
      if (res.status === 200) setReviewData(res.data.reviews);
    } catch {}
  };

  const handleReviewTypeButton = async (type) => {
    setReviewType(type);
    try {
      const res = await axios.get(`${config.SERVER_URL}/api/v1/reviews?review_type=${type}&seller_id=${store.seller.id}`, {
        headers: { Authorization: `Bearer ${jwtToken}` },
      });
      if (res.status === 200) {
        const filtered = res.data.reviews.filter((d) => {
          if (seller?.user?.subscriptions?.[0]?.plan?.name && plans.includes(seller.user.subscriptions[0].plan.name)) {
            return d.reviewable_type === "ListingAnimal";
          }
          return true;
        });
        setReviewData(filtered);
      }
    } catch {}
  };

  const handleApplyFilter = async () => {
    setOpenFilterDialog(false);
    const url = selectedFilter === "all"
      ? `${config.SERVER_URL}/api/v1/reviews?seller_id=${store?.seller_id}`
      : `${config.SERVER_URL}/api/v1/reviews?rating=${selectedFilter}&seller_id=${store?.seller?.id}`;
    try {
      const res = await axios.get(url, { headers: { Authorization: `Bearer ${jwtToken}` } });
      if (res.status === 200) { setReviewData(res.data.reviews); setSelectedFilter("all"); }
    } catch {}
  };

  const handleSlideChange = (swiper) => {
    if (swiper.activeIndex === 1 || swiper.activeIndex === 4) { setIsPlay(true); setIsPlay2(false); setIsPlay3(false); }
    else if (swiper.activeIndex === 2) { setIsPlay(false); setIsPlay2(true); setIsPlay3(false); }
    else { setIsPlay(false); setIsPlay2(false); setIsPlay3(true); }
  };

  const formatDate = (d) => new Date(d).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });

  const countRatings = (reviews) => reviews.reduce((acc, r) => {
    if (r.rating >= 1 && r.rating <= 5) acc[r.rating] += 1;
    return acc;
  }, { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 });

  const ratingCount = countRatings(reviewData);

  const SocialBtn = ({ url, icon }) => url ? (
    <Link to={url} target="_blank" rel="noopener noreferrer">
      <IconButton sx={{ border: "1px solid #2a2a2a", color: "#777", mr: 1, "&:hover": { borderColor: "#FFC001", color: "#FFC001" } }}>{icon}</IconButton>
    </Link>
  ) : null;

  if (loadData) {
    return (
      <Box sx={{ minHeight: "100vh", backgroundColor: "#111", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress sx={{ color: "#FFC001" }} />
      </Box>
    );
  }

  return (
    <>
      {/* ── Filter dialog ── */}
      <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)} PaperProps={{ sx: { backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "14px", minWidth: 280 } }}>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #222", pb: 1.5 }}>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "16px" }}>Filter by Rating</Typography>
          <IconButton onClick={() => setOpenFilterDialog(false)} sx={{ color: "#777", "&:hover": { color: "#FFC001" } }}><ClearIcon /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5 }}>
            <Typography sx={{ color: "#ccc", fontWeight: 600, fontSize: "14px" }}>Stars</Typography>
            <Button onClick={() => setSelectedFilter("all")} sx={{ color: "#FFC001", fontSize: "12px", textTransform: "none", p: 0 }}>Reset</Button>
          </Box>
          <RadioGroup value={selectedFilter} onChange={(e) => setSelectedFilter(e.target.value)}>
            {["all", "5", "4", "3", "2", "1"].map((v) => (
              <FormControlLabel key={v} value={v} control={<Radio sx={{ color: "#555", "&.Mui-checked": { color: "#FFC001" } }} />}
                label={<Typography sx={{ color: "#ccc", fontSize: "14px" }}>{v === "all" ? "All" : `${v} Stars`}</Typography>} />
            ))}
          </RadioGroup>
        </DialogContent>
        <DialogActions sx={{ borderTop: "1px solid #222", p: 2 }}>
          <Button onClick={handleApplyFilter} sx={{ backgroundColor: "#FFC001", color: "#000", fontWeight: 700, textTransform: "none", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#e6ac00" } }}>Apply</Button>
        </DialogActions>
      </Dialog>

      {/* ── See all reviews dialog ── */}
      <SeeAllReviews data={reviewData} openDialog={openDialog} setOpenDialog={setOpenDialog} />

      {/* ── About / Policy modal ── */}
      <Modal open={showMore} onClose={() => setShowMore(false)}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: { xs: "90vw", md: "60vw" }, maxHeight: "80vh", overflow: "auto", backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", outline: "none" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2.5, borderBottom: "1px solid #222" }}>
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "18px" }}>
              {showModal === "About" ? `About — ${store.brand_name}` : `${store.brand_name} — Policy`}
            </Typography>
            <IconButton onClick={() => setShowMore(false)} sx={{ color: "#777", "&:hover": { color: "#FFC001" } }}><Close /></IconButton>
          </Box>
          <Box sx={{ p: 2.5 }}>
            <Typography sx={{ color: "#ccc", fontSize: "14px", lineHeight: 1.8 }}>{showModal === "About" ? about : policy}</Typography>
          </Box>
        </Box>
      </Modal>

      {/* ── Block modal ── */}
      <CustomModal
        title="Block Alert"
        content="Are you sure you want to block this user? This will remove all the conversations, related listings and neighbour stores."
        openModal={openBlockModal}
        closeModal={() => setOpenBlockModal(false)}
        actionTitle="Block"
        setConfirmProp={setConfirmProp}
        actionColor="red"
      />

      <Snackbar open={openSucessAlert} autoHideDuration={3000} onClose={() => setOpenSucessAlert(false)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <Alert onClose={() => setOpenSucessAlert(false)} severity="success" variant="filled">User Blocked Successfully!</Alert>
      </Snackbar>

      <Box sx={{ minHeight: "100vh", backgroundColor: "#111" }}>

        {/* ── Store cover / hero ── */}
        {(() => {
          const hasCustomVideos =
            store?.store_cover && store.store_cover.length > 0;
          const videos = hasCustomVideos
            ? store.store_cover
            : [config.DEFAULT_STORE_VIDEO];
          return (
            <Box sx={{ backgroundColor: "#0d0d0d", borderBottom: "1px solid #1e1e1e" }}>
              <ReactPlayer
                url={videos[activeIndex] || videos[0]}
                controls
                width="100%"
                height="50vh"
                style={{ display: "block" }}
              />
              {videos.length > 1 && (
                <Box sx={{ display: "flex", justifyContent: "center", gap: 1, py: 1.5, px: 2 }}>
                  {videos.map((_, i) => (
                    <Box
                      key={i}
                      onClick={() => setActiveIndex(i)}
                      sx={{
                        width: i === activeIndex ? 28 : 8,
                        height: 8,
                        borderRadius: "4px",
                        backgroundColor: i === activeIndex ? "#FFC001" : "#333",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        "&:hover": { backgroundColor: i === activeIndex ? "#FFC001" : "#555" },
                      }}
                    />
                  ))}
                </Box>
              )}
            </Box>
          );
        })()}

        {/* ── Breadcrumb ── */}
        <Box sx={{ borderBottom: "1px solid #1e1e1e", backgroundColor: "#0d0d0d", py: 1.5 }}>
          <Container maxWidth="xl">
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography component={Link} to="/" sx={{ color: "#777", fontSize: "13px", textDecoration: "none", "&:hover": { color: "#FFC001" } }}>Home</Typography>
              <Typography sx={{ color: "#444", fontSize: "13px" }}>/</Typography>
              <Typography component={Link} to="/neighbour" sx={{ color: "#777", fontSize: "13px", textDecoration: "none", "&:hover": { color: "#FFC001" } }}>Stores</Typography>
              {store?.brand_name && (
                <>
                  <Typography sx={{ color: "#444", fontSize: "13px" }}>/</Typography>
                  <Typography sx={{ color: "#FFC001", fontSize: "13px", fontWeight: 600 }} noWrap>{store.brand_name}</Typography>
                </>
              )}
            </Box>
          </Container>
        </Box>

        <Container maxWidth="xl" sx={{ py: { xs: 3, md: 5 } }}>
          <Grid container spacing={4} alignItems="flex-start">

            {/* ══ LEFT: Store profile ══ */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>

                {/* Logo + name card */}
                <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", overflow: "hidden" }}>
                  {store?.brand_logo?.url && (
                    <Box sx={{ backgroundColor: "#111", p: 2, display: "flex", justifyContent: "center" }}>
                      <img src={store.brand_logo.url} alt={store.brand_name} style={{ maxWidth: "100%", maxHeight: "200px", objectFit: "contain", borderRadius: "10px" }} />
                    </Box>
                  )}
                  <Box sx={{ p: 2.5 }}>
                    <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: "20px", mb: 1.5 }}>{store.brand_name}</Typography>

                    {/* Info rows */}
                    {store.owner_name && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                        <PersonIcon sx={{ color: "#555", fontSize: 16 }} />
                        <Typography sx={{ color: "#ccc", fontSize: "14px" }}>{store.owner_name}</Typography>
                      </Box>
                    )}
                    {store.location && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                        <FmdGoodIcon sx={{ color: "#555", fontSize: 16 }} />
                        <Typography sx={{ color: "#ccc", fontSize: "14px" }}>{store.location}</Typography>
                      </Box>
                    )}
                    {store.phone_number && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                        <LocalPhoneIcon sx={{ color: "#555", fontSize: 16 }} />
                        <Typography sx={{ color: "#ccc", fontSize: "14px" }}>{store.phone_number}</Typography>
                      </Box>
                    )}
                    {store.payment_methods && (
                      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: 1 }}>
                        <PaymentIcon sx={{ color: "#555", fontSize: 16, mt: 0.2 }} />
                        <Typography sx={{ color: "#ccc", fontSize: "14px" }}>{store.payment_methods.join(", ")}</Typography>
                      </Box>
                    )}
                    {store.delivery_option && (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                        {store.delivery_option.includes("local_pickup") && (
                          <Chip icon={<DirectionsCarIcon sx={{ fontSize: "14px !important", color: "#FFC001 !important" }} />} label="Local Pickup" size="small" sx={{ backgroundColor: "rgba(255,192,1,0.1)", color: "#FFC001", border: "1px solid rgba(255,192,1,0.25)", fontWeight: 600, fontSize: "11px" }} />
                        )}
                        {store.delivery_option.includes("regional_pickup") && (
                          <Chip icon={<LocalShippingIcon sx={{ fontSize: "14px !important", color: "#FFC001 !important" }} />} label="Regional Pickup" size="small" sx={{ backgroundColor: "rgba(255,192,1,0.1)", color: "#FFC001", border: "1px solid rgba(255,192,1,0.25)", fontWeight: 600, fontSize: "11px" }} />
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* About */}
                {about && (
                  <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", p: 2 }}>
                    <Typography sx={{ color: "#FFC001", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", mb: 1 }}>About</Typography>
                    <Typography sx={{ color: "#aaa", fontSize: "13px", lineHeight: 1.7 }}>
                      {about.length > 300 ? about.substring(0, 300) + "..." : about}
                    </Typography>
                    {about.length > 300 && (
                      <Button onClick={() => { setShowMore(true); setShowModal("About"); }} sx={{ color: "#FFC001", fontSize: "12px", textTransform: "none", p: 0, mt: 0.5 }}>Read More</Button>
                    )}
                  </Box>
                )}

                {/* Policy */}
                {policy && (
                  <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", p: 2 }}>
                    <Typography sx={{ color: "#FFC001", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", mb: 1 }}>Policy</Typography>
                    <Typography sx={{ color: "#aaa", fontSize: "13px", lineHeight: 1.7 }}>
                      {policy.length > 300 ? policy.substring(0, 300) + "..." : policy}
                    </Typography>
                    {policy.length > 300 && (
                      <Button onClick={() => { setShowMore(true); setShowModal("Policy"); }} sx={{ color: "#FFC001", fontSize: "12px", textTransform: "none", p: 0, mt: 0.5 }}>Read More</Button>
                    )}
                  </Box>
                )}

                {/* Social links */}
                {(store.twitter_url || store.youtube_url || store.facebook_url || store.instagram_url) && (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <SocialBtn url={store.twitter_url} icon={<Twitter sx={{ fontSize: 18 }} />} />
                    <SocialBtn url={store.youtube_url} icon={<YouTube sx={{ fontSize: 18 }} />} />
                    <SocialBtn url={store.facebook_url} icon={<Facebook sx={{ fontSize: 18 }} />} />
                    <SocialBtn url={store.instagram_url} icon={<Instagram sx={{ fontSize: 18 }} />} />
                  </Box>
                )}

                {/* Block button */}
                {user?.id !== store?.seller?.user?.id && user && (
                  <Button fullWidth startIcon={<BlockIcon />} onClick={() => setOpenBlockModal(true)}
                    sx={{ border: "1px solid #3a1a1a", color: "#c0392b", fontWeight: 600, fontSize: "13px", textTransform: "none", borderRadius: "10px", py: 1, "&:hover": { backgroundColor: "rgba(192,57,43,0.08)", borderColor: "#c0392b" } }}>
                    Block User
                  </Button>
                )}

                {/* Ratings overview */}
                <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", p: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                    <Box>
                      <Typography sx={{ color: "#FFC001", fontWeight: 800, fontSize: "32px", lineHeight: 1 }}>{averageRating}</Typography>
                      <Box sx={{ display: "flex", gap: 0.3, mt: 0.5 }}>
                        {[1,2,3,4,5].map((s) => (
                          <StarIcon key={s} sx={{ color: s <= Math.round(averageRating) ? "#FFC001" : "#333", fontSize: 16 }} />
                        ))}
                      </Box>
                      <Typography sx={{ color: "#555", fontSize: "12px", mt: 0.5 }}>{reviewData.length} review{reviewData.length !== 1 ? "s" : ""}</Typography>
                    </Box>
                    <Box sx={{ flex: 1, ml: 2 }}>
                      {[5,4,3,2,1].map((s) => (
                        <RatingBar key={s} stars={s} count={ratingCount[s]} total={reviewData.length} />
                      ))}
                    </Box>
                  </Box>

                  {/* Review type filter */}
                  <Box sx={{ display: "flex", gap: 0.8, flexWrap: "wrap", mb: 1.5 }}>
                    {["all", "animal", "service"].map((t) => (
                      <Box key={t} onClick={() => handleReviewTypeButton(t)}
                        sx={{ cursor: "pointer", px: 1.5, py: 0.5, borderRadius: "20px", fontSize: "12px", fontWeight: 600,
                          backgroundColor: reviewType === t ? "#FFC001" : "transparent",
                          color: reviewType === t ? "#000" : "#777",
                          border: `1px solid ${reviewType === t ? "#FFC001" : "#333"}`,
                          transition: "all 0.2s", "&:hover": { borderColor: "#FFC001", color: reviewType === t ? "#000" : "#FFC001" },
                        }}>
                        {t === "all" ? "All" : t === "animal" ? "Animals" : "Services"}
                      </Box>
                    ))}
                    <Box sx={{ ml: "auto", display: "flex", gap: 0.8, alignItems: "center" }}>
                      <Select value={selectedSortValue} onChange={handleSortChange} size="small"
                        sx={{ height: 28, fontSize: "12px", color: "#ccc", "& .MuiOutlinedInput-notchedOutline": { borderColor: "#333" }, "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#FFC001" }, "& .MuiSvgIcon-root": { color: "#777" } }}>
                        <MenuItem value="Newest">Newest</MenuItem>
                        <MenuItem value="Oldest">Oldest</MenuItem>
                        <MenuItem value="Default">Default</MenuItem>
                      </Select>
                      <IconButton size="small" onClick={() => setOpenFilterDialog(true)} sx={{ border: "1px solid #333", color: "#777", "&:hover": { borderColor: "#FFC001", color: "#FFC001" } }}>
                        <TuneIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Box>
                  </Box>

                  {/* Review list */}
                  {reviewData.length === 0 && (
                    <Typography sx={{ color: "#555", fontSize: "13px", textAlign: "center", py: 2 }}>No reviews yet</Typography>
                  )}
                  {reviewData.slice(0, 3).map((data, i) => (
                    <Box key={i}>
                      {i > 0 && <Divider sx={{ borderColor: "#222", my: 1.5 }} />}
                      <Box sx={{ display: "flex", gap: 1.5, mt: i === 0 ? 0 : 0 }}>
                        <Avatar src={data.user.avatar_url} sx={{ width: 36, height: 36 }} />
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "13px" }} noWrap>{data.user.full_name}</Typography>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Rating value={data.rating} readOnly size="small" icon={<StarIcon sx={{ color: "#FFC001", fontSize: 13 }} />} emptyIcon={<StarIcon sx={{ color: "#333", fontSize: 13 }} />} />
                          </Box>
                          <Typography sx={{ color: "#555", fontSize: "11px", mb: 0.5 }}>
                            {formatDate(data.created_at)} ·{" "}
                            <Box component={Link}
                              to={data.reviewable_type === "ListingService"
                                ? `/services/${data.reviewable.category_or_service?.category?.id}/subService/${data.reviewable.category_or_service?.sub_category?.id}/listings/${data.reviewable.id}`
                                : "/listing/" + data.reviewable.id}
                              sx={{ color: "#FFC001", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>
                              {data.reviewable.name}
                            </Box>
                          </Typography>
                          <Typography sx={{ color: "#aaa", fontSize: "13px", lineHeight: 1.6 }}>{data.content}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                  {reviewData.length > 3 && (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                      <Button onClick={() => setOpenDialog(true)} sx={{ color: "#FFC001", fontSize: "13px", textTransform: "none", border: "1px solid rgba(255,192,1,0.3)", borderRadius: "8px", px: 2.5, py: 0.6, "&:hover": { backgroundColor: "rgba(255,192,1,0.08)" } }}>
                        See All {reviewData.length} Reviews
                      </Button>
                    </Box>
                  )}
                </Box>

              </Box>
            </Grid>

            {/* ══ RIGHT: Listings content ══ */}
            <Grid item xs={12} md={8}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>

                {/* Trophy Case */}
                {store?.trophy_cases?.length > 0 && (
                  <Box>
                    <SectionHead icon={<EmojiEventsIcon sx={{ color: "#FFC001", fontSize: 22 }} />} label="Trophy" accent="Case" />
                    {store.trophy_cases.length > 3 ? (
                      <Swiper
                        style={{ "--swiper-navigation-color": "#FFC001" }}
                        navigation modules={[Navigation, Scrollbar]}
                        grabCursor loop
                        breakpoints={{ 320: { slidesPerView: 1 }, 600: { slidesPerView: 2 }, 900: { slidesPerView: 3 } }}
                      >
                        {store.trophy_cases.map(({ listing_animal }, i) => (
                          <SwiperSlide key={i} style={{ padding: "4px 8px" }}>
                            <Box component={Link} to={"/listing/" + listing_animal.id} sx={{ textDecoration: "none", display: "block" }}>
                              <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", overflow: "hidden", transition: "all 0.25s", "&:hover": { borderColor: "#FFC001" } }}>
                                <Box sx={{ height: 150, backgroundImage: `url(${listing_animal.media?.[0]?.url})`, backgroundSize: "cover", backgroundPosition: "center", position: "relative" }}>
                                  <Chip label={listing_animal.status.toUpperCase()} size="small" sx={{ position: "absolute", top: 8, right: 8, backgroundColor: listing_animal.status === "sold" ? "#c0392b" : "#111", color: "#fff", fontWeight: 700, fontSize: "10px" }} />
                                </Box>
                                <Box sx={{ p: 1.5 }}>
                                  <Typography noWrap sx={{ color: "#fff", fontWeight: 700, fontSize: "13px" }}>{listing_animal.name}</Typography>
                                  <Typography sx={{ color: "#FFC001", fontWeight: 700, fontSize: "14px" }}>${listing_animal.price}</Typography>
                                </Box>
                              </Box>
                            </Box>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    ) : trophyListings.length > 0 && (
                      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "repeat(2,1fr)", sm: "repeat(3,1fr)", md: "repeat(4,1fr)" } }}>
                        <ListCard listData={trophyListings} classes={classes} />
                      </Box>
                    )}
                  </Box>
                )}

                {/* Animal Listings */}
                {displayAnimalListings.length > 0 && (
                  <Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2.5 }}>
                      <SectionHead icon={<PetsIcon sx={{ color: "#FFC001", fontSize: 22 }} />} label="Animal" accent="Listings" />
                      <Box onClick={() => navigate("/listings/seller/" + store.seller_id)}
                        sx={{ cursor: "pointer", backgroundColor: "#FFC001", color: "#000", fontWeight: 700, fontSize: "13px", px: 2.5, py: 0.8, borderRadius: "20px", "&:hover": { backgroundColor: "#e6ac00" } }}>
                        See All
                      </Box>
                    </Box>
                    <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "repeat(2,1fr)", sm: "repeat(3,1fr)", md: "repeat(4,1fr)" } }}>
                      <ListCard listData={displayAnimalListings.slice(0, 8)} classes={classes} />
                    </Box>
                  </Box>
                )}

                {/* Service Listings */}
                {displayServiceListings.length > 0 && (
                  <Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2.5 }}>
                      <SectionHead icon={<MiscellaneousServicesIcon sx={{ color: "#FFC001", fontSize: 22 }} />} label="Service" accent="Listings" />
                      <Box onClick={() => navigate("/service/listings/seller/" + store.seller_id)}
                        sx={{ cursor: "pointer", backgroundColor: "#FFC001", color: "#000", fontWeight: 700, fontSize: "13px", px: 2.5, py: 0.8, borderRadius: "20px", "&:hover": { backgroundColor: "#e6ac00" } }}>
                        See All
                      </Box>
                    </Box>
                    <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "repeat(2,1fr)", sm: "repeat(3,1fr)", md: "repeat(4,1fr)" } }}>
                      <ServiceListCard listData={displayServiceListings.slice(0, 8)} classes={classes} />
                    </Box>
                  </Box>
                )}

                {/* Empty state */}
                {displayAnimalListings.length === 0 && displayServiceListings.length === 0 && !loadData && (
                  <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", p: 5, textAlign: "center" }}>
                    <PetsIcon sx={{ color: "#333", fontSize: 48, mb: 1.5 }} />
                    <Typography sx={{ color: "#555", fontSize: "15px" }}>No listings yet</Typography>
                  </Box>
                )}

              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

const mapStateToProps = ({ Auth, Seller, Listings, Categories }) => ({
  user: Auth.user,
  jwtToken: Auth.jwtToken,
  seller: Seller.seller,
  listings: Listings.listings,
  classes: Categories.classes,
  serviceListing: Listings.serviceListing,
});

const mapDispatchToProps = (dispatch) => ({
  setStore: (data) => dispatch(Actions.setStore(data)),
  loadListings: (sellerId) => dispatch(Actions.thunkLoadListing(sellerId)),
  loadServiceListings: ({ store_id }) => dispatch(Actions.thunkLoadServiceListings({ store_id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreDetails);
